// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangePassword_container__1V26x","password":"ChangePassword_password__12MqH","saveButton":"ChangePassword_saveButton__vMjP4"};